import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
  decimalScaleByCurrency,
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../utils/Currency";
import { roundNumber } from "../../services/app";
import { useApp } from "../../contexts";
import { cancelSubShopifyScription } from "../../services/app";
import { dateFormat } from "../../utils/helper";
import { ModalConfirm } from "./ModalConfirm";
import * as Notification from "../../Notification"
import { dateFormatNumber } from "../../utils/helper";
import { useMemo } from "react";

function ItemBonusCheercast(props) {
  const { T, user, convertToLocalCurrency, formatLocalCurrency, getCurrency } =
    useApp();
  const { itemData, handleReload } = props;
  const [price, setPrice] = useState(0);
  const [isOpenModalCancel, setIsOpenModalCancel] = useState(false);
  const [isOpenModalCancelSuccess, setIsOpenModalCancelSuccess] =
    useState(false);

  const openModalCancelSubscription = () => {
    setIsOpenModalCancel(true);
  };
  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(
          itemData?.price,
          itemData?.currency_code,
          getCurrency()
        )
      );
    }
  }, [itemData]);

  const handleCancelSubscription = () => {
    cancelSubShopifyScription(itemData.id)
      .then((res) => {
        if (res.data?.data) {
          setIsOpenModalCancel(false);
          handleReload();
          Notification.success(
            T("Success! Your subscription has been canceled!")
          );
        } else {
          Notification.error(T("Failed to cancel subscription"));
        }
      })
      .catch((err) => {
        Notification.error(T("Failed to cancel subscription"));
      });
  };

  const periodOfSub =  useMemo(() => {
    const arrayProductSku = itemData?.product_sku?.split('_');
    const period = arrayProductSku[arrayProductSku.length - 1];
    switch (period) {
      case '1W':
        return {
          key: '{time} week',
          value: 1
        }
      case '1M':
        return {
          key: '{time} month',
          value: 1
        }
      case '3M':
        return {
          key: '{time} month',
          value: 3
        }
      case '1Y':
        return {
          key: '{time} year',
          value: 1
        }
      default: 
        return {
          key: '',
          value:''
        }
    }
  }, [itemData])

  return (
    <>
      <div className={`w-auto item-boxs suzu-card cursor-pointer`}>
        <div className="rounded-[12px] lg:rounded-[10px] xls:rounded-[13px] flex items-center justify-center relative">
          <div
            className={`aspect-[196/114] lg:aspect-[233/135] max-h-[160px] w-full relative rounded-t-[12px] lg:rounded-t-[10px] xls:rounded-t-[13px] suzu-earner-img bg-[#F7F7F7]
              ${"overflow-hidden"}`}
          >
            <div className="w-full relative h-full suzu-earner-img-wrap">
              <img
                src={itemData?.product_image}
                className={`w-full h-full object-fill`}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="suzu-card-body">
          <div className={`w-full h-full pt-[0]`}>
            <div className="flex flex-col w-full bg-[#F3850F1A] px-[15px] py-[8px]">
              <p className="leading-[18px] text-[16px] text-[#000000] font-[600] truncate text-center">
                {itemData?.product_name}
              </p>
              <p className="text-[12px] text-[#F12E11] text-center">
                {T(periodOfSub.key).replace("{time}", periodOfSub.value)}
              </p>
            </div>
          </div>
          <div className="mb-[8px] lg:mb-[14px] lg:mt-[14px] flex items-center justify-center">
            <span className={`text-[16px] text-[#000000]`}>&nbsp;</span>
            <div>
              <span
                className={`text-[#000000] md:text-[24px] lg:text-[24px] xl:text-[24px] text-[28px] font-bold`}
              >
                <NumberFormat
                  className=""
                  value={price}
                  displayType={"text"}
                  thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                  decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                  prefix={prefixCcySymbol(true, getCurrency())}
                  suffix={suffixCcySymbol(true, getCurrency())}
                  decimalScale={decimalScaleByCurrency(
                    baseCurrencyCode(true, getCurrency())
                  )}
                />
                &nbsp;
              </span>
              <span className={`text-[#000000]`}>/{T("month")}</span>
              <div
                style={{
                  borderBottom: "3px solid #000000",
                  margin: "0 auto",
                }}
                className="w-[90%]"
              ></div>
            </div>
          </div>
          <div
            className={`flex flex-col items-center lg:px-[20px] h-[60px]
           lg:pt-[5px] px-[30px] pt-[5px] pb-[0]`}
          >
            {itemData?.status == 1 && itemData?.user_canceled === 0 && (
              <div
                className="mt-[16px] italic mb-[0px] text-[14px] text-normal text-[#F3850F] text-center hover:underline cursor-pointer"
                onClick={() => {
                  openModalCancelSubscription();
                }}
              >
                {T("Cancel Subscription")}
              </div>
            )}
            {itemData?.status == 4 && (
              <div className="mt-[12px] italic mb-[5px] text-[14px] text-[#FF5748] text-center">
                {T("Cancelled")}
              </div>
            )}
          </div>
          <div
            className={`bg-[#F3850F1A] rounded-b-[13px] rounded-t-[0] 
        flex justify-center items-center text-[12px] text-black h-[26px]`}
          >
            {itemData.user_canceled === 0
              ? T("Next payment: {date}").replace(
                  "{date}",
                  dateFormatNumber(itemData?.end_date_ms, "YYYY/MM/DD")
                )
              : T("Expires on {date}").replace(
                  "{date}",
                  dateFormatNumber(itemData.end_date_ms, "YYYY/MM/DD")
                )}
          </div>
        </div>
      </div>
      {isOpenModalCancel && (
        <ModalConfirm
          title={T("Cancel Subscription")}
          des={T(
            "Are you sure you want to cancel this subscription? After confirm, the subscription charge will be canceled on {date} and you will not be able to resubscribe to that subscription."
          ).replace("{date}", dateFormat(itemData?.end_date, "YYYY/MM/DD"))}
          onClose={() => setIsOpenModalCancel(false)}
          onSubmit={() => handleCancelSubscription()}
        />
      )}
    </>
  );
}

export default ItemBonusCheercast;
